import React, { FC, Fragment, ReactNode } from 'react';

import { PostedToGroup, useGetPostedToGroupsQuery } from 'api';
import { QueryManager } from 'components';

interface IProps {
  children: (postedToGroups: PostedToGroup[]) => ReactNode;
}

const GetPostedToGroups: FC<IProps> = ({ children }) => {
  const queryResult = useGetPostedToGroupsQuery();

  return (
    <QueryManager loader={<Fragment>{children([])}</Fragment>} {...queryResult}>
      {({ data }) => {
        return <Fragment>{children(data?.contextGetPostedToGroups || [])}</Fragment>;
      }}
    </QueryManager>
  );
};

export default GetPostedToGroups;
